import { AccordionPlaceholder } from '../accordion-placeholder';
import { CollapsePanelTitle } from '../captions/collapse-panel-title';
import { HelpCenterContent } from '../help-center-content';

export const QuoteDashboardHelpCenterContent = () => {
  return (
    <HelpCenterContent
      defaultActiveKey={[]}
      helpCaptionTitle="Help with Quote Dashboard"
      panelItems={[
        {
          children: <AccordionPlaceholder>Coming soon</AccordionPlaceholder>,
          key: '1',
          label: <CollapsePanelTitle>How to use Quote Dashboard</CollapsePanelTitle>,
        },
      ]}
    />
  );
};
